import { Alert, AppBar, Box, Button, CircularProgress, Paper, Tab, Tabs, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { useApi } from '../../../../services/HttpService';
import { Paymentprofile, newPaymentprofile, PrepaymentSolution, newPrepaymentSolution, ErpSolution, newErpSolution } from '../../../../model/PaymentProfile';
import { PaymentProfileForm, PaymentProfileFormRef } from '../../../../model/forms/PaymentProfileForm';
import { TabPanel, TabProps } from '../../../../components/ui/TabPanel';
import { DataInfoTable, DataListInfoTable } from '../../../../components/tables/DataTable';
import { ErpSolutionForm, ErpSolutionFormRef } from '../../../../model/forms/ErpSolutionForm';
import { PrepaymentSolutionForm, PrepaymentSolutionFormRef } from '../../../../model/forms/PrepaymentSolutionForm';

interface PaymentprofileOverviewProps {
  item: Paymentprofile;
  getError?: string;
  onClose?: () => void;
  ErpSolutions?: ErpSolution[];
  PrepaymentSolutions?: PrepaymentSolution[];
  onItemChange?: (item: Paymentprofile) => void;
}

export const PaymentprofileOverview = (props: PaymentprofileOverviewProps) => {
  const theme = useTheme();
  const { getError, ErpSolutions, PrepaymentSolutions, onItemChange} = props;
  const { api, error, isLoading } = useApi();
  const { api: modApi, error: modError, isLoading: modIsLoading } = useApi();
  const addPaymentprofileRef = useRef<PaymentProfileFormRef>(null);
  const addPrePaymentRef = useRef<PrepaymentSolutionFormRef>(null);
  const addErpRef = useRef<ErpSolutionFormRef>(null);
  const [item, setItem] = useState<Paymentprofile>(props.item);
  const [erpSolution, setErpSolution] = useState<ErpSolution>(newErpSolution());
  const [prepaymentSolution, setPrepaymentSolution] = useState<PrepaymentSolution>(newPrepaymentSolution());
  const [displayData, setDisplayData] = useState<Record<string, string>>(null);
  const [displayDataPrepayment, setDisplayDataPrepayment] = useState<Record<string, string>>(null);
  const [displayDataErp, setDisplayDataErp] = useState<Record<string, string>>(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [PrepaymentSolutionList, setPrepaymentSolutionList] = useState<PrepaymentSolution[]>([]);
  const [ErpSolutionList, setErpSolutionList] = useState<ErpSolution[]>([]);
  const [SelectedPrepaymentSolution, setSelectedPrepaymentSolution] = useState<PrepaymentSolution>(null);
  const [SelectedErpSolution, setSelectedErpSolution] = useState<ErpSolution>(null);

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

//   const getData = () => {
    
//   }

  useEffect(() => {
    if (!props.item || props.item.id === 0) {
      setTabIndex(1);
    } else {
      setDisplayData({
        "ID": String(props.item.id),
        "Navn": props.item.name,
        "Ekstern ID": props.item.external_id,
        "Post bestilling": props.item.post_ordering ? "Ja" : "Nei",
        "Lønnstrekk": props.item.salary_deduction ? "Ja" : "Nei",
        "Forhåndsbetaling": props.item.order_prepayment_solution_id? String(props.item.order_prepayment_solution_id) : "",
        "Økonomi løsning": props.item.order_erp_solution_id? String(props.item.order_erp_solution_id) : "",
        "Endrings kriterier": props.item.available_options_for_change,
      })
    }

    
    // const connectedErp = props.ErpSolutions?.find(
    //     (order) => order.id === props.paymentprofile.order_erp_solution_id
    // );

    // const connectedPrepayment = props.PrepaymentSolutions?.find(
    //     (order) => order.id === props.paymentprofile.order_prepayment_solution_id
    // );
    
    // if(connectedPrepayment){
    //     setPrepaymentSolution(connectedPrepayment)
    //     setDisplayDataPrepayment({
    //         "ID": String(connectedPrepayment.id),
    //         "Navn": connectedPrepayment.name,
    //         "Client_ID": connectedPrepayment.client_id,
    //         "URL": connectedPrepayment.url,
    //         "Username": connectedPrepayment.username,
    //         "Token1": connectedPrepayment.token1,
    //         "Token2": connectedPrepayment.token2,
    //     })
    // }

    // if(connectedErp){
    //     setErpSolution(connectedErp)
    //     setDisplayDataErp({
    //         "ID": String(connectedErp.id),
    //         "Navn": connectedErp.name,
    //         "Client_ID": connectedErp.client_id,
    //         "URL": connectedErp.url,
    //         "Username": connectedErp.username,
    //         "Token1": connectedErp.token1,
    //         "Token2": connectedErp.token2,
    //     })
    // }
  }, [props.item]);

  useEffect(() => {
    setErpSolutionList(props.ErpSolutions)
  },[props.ErpSolutions]);

  useEffect(() => {
    setPrepaymentSolutionList(props.PrepaymentSolutions)
  },[props.PrepaymentSolutions]);

  const reset = () => {
    setItem(() => ({ ...item, password: "" })); // triggers props.paymentprofile change in PaymentprofileForm
  }

  const savePaymentProfile = () => {
    if (!addPaymentprofileRef.current) return;

    // Validate the form
    if (!addPaymentprofileRef.current.valid()) {
      console.log("Validation failed");
      return;
    }
  
    // Get form data
    const paymentprofileRef = addPaymentprofileRef.current.getPaymentprofile();
    console.log("Saving data:", paymentprofileRef);

    if (addPaymentprofileRef.current.valid()) {
      api("/manage/order/paymentprofile", "POST", { ...paymentprofileRef }).then(res => {
        console.log("res:", res)
        if (res?.statusCode === 200) {
          if (res.paymentprofile){
            onItemChange(res.paymentprofile);
          }
          setTabIndex(0);
        }
      });
    }
  };

  const savePrepayment = () => {
    if (!addPrePaymentRef.current){
      alert("Not current");
        return;
    }
    // Validate the form
    if (!addPrePaymentRef.current.valid()) {
      console.log("Validation failed");
      alert("Not valid");
      return;
    }
  
    // Get form data
    const formData = addPrePaymentRef.current.getPrepaymentSolution();
    console.log("Saving data:", formData);

    if (addPrePaymentRef.current.valid()) {
      api("/manage/order/prepaymentsolution", "POST", { ...formData }).then(res => {
        console.log("res:", res)
        if (res?.statusCode === 200) {
          // onItemChange(res.payment_profile);
          setTabIndex(0);
        }
      });
    }
  };

  const saveErp = () => {
    if (!addErpRef.current) return;
  
    // Validate the form
    if (!addErpRef.current.valid()) {
      console.log("Validation failed");
      return;
    }
  
    // Get form data
    const formData = addErpRef.current.getErpSolution();
    console.log("Saving data:", formData);

    if (addErpRef.current.valid()) {
      api("/manage/order/erpsolution", "POST", { ...formData }).then(res => {
        console.log("res:", res)
        if (res?.statusCode === 200) {
          // onItemChange(res.payment_profile);
          setTabIndex(0);
        }
      });
    }
  };

  const changeTab = (index: number, performChange: boolean = true): boolean => {
    if (!item.id) {
      if (performChange) {
        setTabIndex(1);
      }

      return index === 1
    }

    if (performChange) {
      setTabIndex(index);
    }

    return true;
  }

  return (
    <>
      <AppBar position="static"
        sx={{
          backgroundColor: theme.palette.mode === 'dark' ? "inherit" : theme.palette.grey[300],
          color: theme.palette.mode === 'dark' ? "white" : "black"
        }}
      >
        <Tabs
          value={tabIndex}
          onChange={(_, newValue) => setTabIndex(newValue)}
          variant={"scrollable"}
          textColor="inherit"
          indicatorColor="primary"
          aria-label="manage paymentprofile tabs"
        >
          {[
            "Oversikt",
            item.id ? "Rediger" : "Opprett",
            // "Prepayment solution",
            // "Erp solution",
          ].map((name, index) => (
            <Tab disabled={!changeTab(index, false)}  key={index} label={name} sx={{ fontWeight: "bold", textTransform: "none" }} {...TabProps(index)} />
          ))}
        </Tabs>
      </AppBar>
      <Box sx={{ p: { xs: 1, md: 3 }, pt: 3, minHeight: 400 }}>
        <TabPanel value={tabIndex} index={0} sx={{ minHeight: 200 }}>
          <Box sx={{ p: { xs: 1, md: 3 }, display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ maxWidth: { xs: "100%", md: 1200 } }}>
              <DataInfoTable title={"Betalingsmåte"} data={displayData} onEdit={() => changeTab(1)} />
              {props.onClose && (
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', p: 2 }}>
                  <Button variant='contained' color='darkgrey' onClick={props.onClose}>Lukk</Button>
                </Box>
              )}
            </Box>
          </Box>
        </TabPanel>
        <TabPanel value={tabIndex} index={1} sx={{ minHeight: 200 }}>
          <Box sx={{ p: { xs: 1, md: 3 }, display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ maxWidth: 1200 }}>
              <PaymentProfileForm paymentprofile={item} ErpSolutionList={ErpSolutionList} PrepaymentSolutionList={PrepaymentSolutionList} error={getError} ref={addPaymentprofileRef} />
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, p: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {/* <Button variant='contained' color='info' onClick={setDefault}>Default</Button> */}
                  <Button variant='contained' color='darkgrey' onClick={reset}>Tilbakestill</Button>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                  <Button
                    variant='contained'
                    color='darkgrey'
                    onClick={() => {
                      if (changeTab(0, false)) {
                        changeTab(0);
                      } else if (props.onClose) {
                        props.onClose();
                      }
                    }}
                  >
                    Avbryt
                  </Button>
                  <Button
                    variant='contained'
                    color='info'
                    onClick={savePaymentProfile}
                    disabled={isLoading}
                    endIcon={isLoading && <CircularProgress size={22} />}
                  >
                    {item.id ? "Lagre" : "Opprett"}
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </TabPanel>
        {/* <TabPanel value={tabIndex} index={2} sx={{ minHeight: 200 }}>
        <Box sx={{ p: { xs: 1, md: 3 }, display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ maxWidth: 1200 }}>
              <PrepaymentSolutionForm 
                PrepaymentSolution={prepaymentSolution} 
                PrepaymentSolutionList={PrepaymentSolutionList} 
                error={getError} 
                ref={addPrePaymentRef} 
              />
              <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 2, p: 2 }}>
                <Button variant="contained" color="darkgrey" onClick={() => setTabIndex(0)}>Avbryt</Button>
                <Button 
                  variant="contained" 
                  color="info" 
                  onClick={savePrepayment} 
                  disabled={isLoading} 
                  endIcon={isLoading && <CircularProgress size={22} />}
                >
                  {"Lagre"}
                </Button>
              </Box>
            </Box>
          </Box>
        </TabPanel> */}
        {/* <TabPanel value={tabIndex} index={3} sx={{ minHeight: 200 }}>
        <Box sx={{ p: { xs: 1, md: 3 }, display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ maxWidth: 1200 }}>
              <ErpSolutionForm 
                ErpSolution={erpSolution} 
                ErpSolutionList={ErpSolutionList} 
                error={getError} 
                ref={addErpRef} 
              />
              <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 2, p: 2 }}>
                <Button variant="contained" color="darkgrey" onClick={() => setTabIndex(0)}>Avbryt</Button>
                <Button 
                  variant="contained" 
                  color="info" 
                  onClick={saveErp} 
                  disabled={isLoading} 
                  endIcon={isLoading && <CircularProgress size={22} />}
                >
                  {"Lagre"}
                </Button>
              </Box>
            </Box>
          </Box>
        </TabPanel> */}
      </Box>
    </>
  )
}